import { Box, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import ModalFooter from './_ModalFooter'
import ModalHeader from './_ModalHeader'

interface Props {
  onClose: () => void
}

const UpsellModalModulesError = ({ onClose }: Props) => {
  return (
    <Modal
      title=""
      onClose={onClose}
      background="radial-gradient(100% 100% at 90% 10%, rgb(247, 215, 211, 100) 0%, rgb(255, 255, 255) 100%)"
    >
      <Box style={{ marginTop: '-72px' }}>
        <Box paddingBottom="s16">
          <Text.Header3>{i18n.t('upsell.request_modal.error.title')}</Text.Header3>
        </Box>
        <Box flexDirection="column" alignItems="center" gap="s24">
          <ModalHeader />
        </Box>
        <ModalFooter onClose={onClose} onDiscoverMore={onClose} />
      </Box>
    </Modal>
  )
}

export default UpsellModalModulesError
